import { AntdSelect, Loading } from '@/components';
import React, { useCallback, useMemo } from 'react';

import styles from './index.module.scss';
import { ChainDetail, useChainList } from './hooks';

const { Option } = AntdSelect;

export const ChainSelect = ({
  value,
  onChange,
}: {
  value?: string;
  onChange: (val: ChainDetail) => void;
}) => {
  const { data, isLoading } = useChainList();
  const options = useMemo(
    () => data?.chains?.map(i => ({ label: i?.name, value: i?.id })) || [],
    [data?.chains],
  );
  const emptyContent = useMemo(() => <div className={styles.empty}>No Match</div>, []);
  const handleChange = useCallback(
    (val: string) => {
      const chainDetail = data?.chains?.find(i => i.id === val);
      if (chainDetail) {
        onChange(chainDetail);
      }
    },
    [data?.chains, onChange],
  );
  return (
    <AntdSelect
      value={options && !isLoading ? value : ''}
      onChange={val => handleChange(val as string)}
      showSearch
      placeholder="Select chain"
      className={styles.chainSelect}
      optionFilterProp="label"
      filterOption={(input, option) =>
        (option?.props?.label as string)?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0
      }
      notFoundContent={!isLoading ? emptyContent : <Loading />}>
      {options?.map(({ value, label }) => (
        <Option key={value} className={styles.option} value={value} label={label}>
          {label}
        </Option>
      ))}
    </AntdSelect>
  );
};
